
import * as React from "react"
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card"
import { TrendingUp, TrendingDown, LucideIcon } from "lucide-react"
import { cn } from "@/lib/utils"

interface MetricCardProps {
  title: string
  value: string
  description: string
  trend?: number
  trendLabel?: string
  icon?: LucideIcon
}

export function MetricCard({
  title,
  value,
  description,
  trend,
  trendLabel,
  icon: Icon,
}: MetricCardProps) {
  const isPositive = trend && trend > 0
  const isNegative = trend && trend < 0
  const isTrendGood = (isPositive && title !== "Cycle Time") || (isNegative && title === "Cycle Time")
  
  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-sm font-medium">
          {title}
        </CardTitle>
        {Icon && <Icon className="h-4 w-4 text-muted-foreground" />}
      </CardHeader>
      <CardContent>
        <div className="text-2xl font-bold">{value}</div>
        <CardDescription>{description}</CardDescription>
        {trend !== undefined && (
          <div className="mt-2 flex items-center text-xs">
            <span className={cn(
              "flex items-center",
              isTrendGood ? "text-emerald-600" : "text-red-600"
            )}>
              {isPositive ? (
                <TrendingUp className="mr-1 h-3 w-3" />
              ) : (
                <TrendingDown className="mr-1 h-3 w-3" />
              )}
              {Math.abs(trend)}
            </span>
            {trendLabel && (
              <span className="ml-1 text-muted-foreground">
                {trendLabel}
              </span>
            )}
          </div>
        )}
      </CardContent>
    </Card>
  )
}
